import React from 'react'
import {connect} from 'react-redux'

import closeModal from './data/actions/close_modal'

import ModalView from './modal_view'
import StartSessionForm from './start_session_form'

class SessionInitiateModal extends React.Component {
  constructor (props) {
    super(props)

    this.onClose = this.onClose.bind(this)
  }

  onClose (e) {
    if(e) e.stopPropagation()

    this.props.closeModal(this.props.modalKey)
  }

  renderModalContent () {
    return (
      <div className='session-initiate-modal-content'>
        <div className='modal-header'>
          <h4>Start premium session with {this.props.expert.get('name')}</h4>
        </div>
        <div className='modal-body' style={{padding: 0}}>
          <StartSessionForm expert={this.props.expert} bookData={this.props.bookData}/>
        </div>
        <div className='modal-footer'>
          <div className='actions right'>
            <div className='cancel button default' onClick={this.onClose}>Close</div>
          </div>
        </div>
      </div>
    )
  }

  render () {
    return (
      <ModalView isActive={true} onClose={this.onClose}>
        {this.renderModalContent()}
      </ModalView>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: (modalKey) => dispatch(closeModal(modalKey))
  }
}

const SessionInitiateModalContainer = connect(
  null, mapDispatchToProps
)(SessionInitiateModal)

export default SessionInitiateModalContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/session_initiate_modal.js
 **/